import { useTheme } from "@/comn/hooks";
import { _TEST1234 } from "../../config/ApiConfig";

export const Logo = () => {
    const {
        theme: { isDark },
    } = useTheme();

    const SRCS = {
        tanoga: {
            logo: `${process.env.PUBLIC_URL}/imgs/egaLogo.png`,
            light: `${process.env.PUBLIC_URL}/imgs/osc_title_light.webp`,
            dark: `${process.env.PUBLIC_URL}/imgs/osc_title_dark.webp`,
        },
    };

    const src = SRCS[_TEST1234.SYSTEM_GROUP_ORI as keyof typeof SRCS];
    const alt = process.env.REACT_APP_SYSTEM_GROUP_NAME;
    const name = process.env.REACT_APP_SYSTEM_GROUP_NAME;

    return (
        <a href={window.location.origin + "/osci"}>
            <div className="flex items-center gap-2 min-h-[60px]">
                {/* <img src={src["logo"]} alt={alt} title={name} width={40} height={40} /> */}
                <img src={src["logo"]} alt={alt} title={name} width={40} height={40} className="h-10 w-10" />
                <img
                    loading={isDark === "true" ? "lazy" : undefined}
                    src={src["light"]}
                    alt={alt}
                    title={name}
                    hidden={isDark === "true"}
                    width={170}
                    height={35}
                />
                <img
                    loading={isDark === "false" ? "lazy" : undefined}
                    src={src["dark"]}
                    alt={alt}
                    title={name}
                    hidden={isDark === "false"}
                    width={170}
                    height={35}
                    // className="h-[35px]"
                />
            </div>
        </a>
    );
};
